module.exports = __webpack_public_path__ + "img/logo-e-sea-black.5297957f.png";